import { render, staticRenderFns } from "./AssignPermissionToRole.vue?vue&type=template&id=c3179154&"
import script from "./AssignPermissionToRole.vue?vue&type=script&lang=js&"
export * from "./AssignPermissionToRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports